
<script>
    import Vue from 'vue'
    import Axios from 'axios'
    import _ from 'lodash'
    import api from '../../api'
    import { mapGetters, mapActions } from 'vuex'
    
    //import _systemServices from '../../libs/system/services';

	import AOS from 'aos'
    import 'aos/dist/aos.css'

    import  OnboardingPages  from "./OnboardingPages";
	
	export default 
	{
        name: 'accounts',
        components: {
            OnboardingPages
        },
		data() 
        {
        	return {
                pages: [],
                platforms: [],

        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser','getJwt', 'getWhiteLabel']),
	        ...mapGetters('accounts', ['accounts', 'accountsByName']),
	        ...mapGetters('networks', ['networks', 'networksByName']),
	        ...mapGetters('mobileMenu', ['rightMobileMenu']),
          ...mapGetters('htmlModals', ['modals']),
          ...mapGetters('tags', ['tagsByName']),
          ...mapGetters('workspaces', ['currentWorkspaceSettings']),
        },
        methods: {
            ...mapActions('session', ['setUser']),
            ...mapActions('statuses', ['setStatuses']),
            ...mapActions('accounts', ['setAccounts']),
            ...mapActions('networks', ['setNetworks']),
            ...mapActions('mobileMenu', ['toggleRightMenu']),
        },
         created(){
            AOS.init(); 

            let menu = [
              { 
                _id: '5e469e39f9d2578b0f53e465',
                name: 'Gmail',
                removed: true
                },
                                {
                 _id: '5c0bcfb235563f46ca2921bd',
                name: 'Facebook' 
                },
              { 
                _id: '5c0bcfb335563f46ca2921cb',
                name: 'Instagram' 
                },
              { 
                _id: '6525b45780f8bb8ccd0263d3',
                name: 'Shopify' 
                },
              { 
                _id: '5c0bcfb235563f46ca292149',
                name: 'Twitter' 
                },
              { 
                _id: '5e716de3bc83c01b553f1282',
                name: 'LinkedIn',
                image: 'linkedIn'
                },
              { 
                _id: '5c1109f435563f46ca8a7ad9',
                name: 'Youtube',
                sub: 'Youtube'
               },
              { 
                _id: '5dc592bd808a68c722761bd9',
                name: 'Email',
                sub: 'Email - SMTP/IMAP',
                image: 'email',
                url: 'email',
                removed: true
                },
              { 
                _id: '5e317dcfa36c3336dbb20880',
                name: 'WhatsApp',
                sub: 'WhatsApp',
                image: 'whatsapp',
                url: 'whatsapp',
                removed: true
               },
              { 
                _id: '60355634790f263eedb4e45b',
                name: 'Twilio',
                sub: 'WhatsApp',
                image: 'whatsapp',
                url: 'whatsapp',
                removed: true
               },
               { 
                _id: '642ae982399fe2be2591aa48',
                name: 'Trustpilot',
                image: 'trustPilot',
                imageType: '.png'
                },
              { 
                _id: '5ee3c607d0e32c86e627f353',
                name: 'Google My Business',
                image: 'googleMyBusiness'
                },
              { 
                _id: '5d111648894b33a713625cc7',
                name: 'Google Play',
                image: 'playStore'
                },
              { 
                _id: '5e0761e79133ee6990836d1a',
                name: 'App Store',
                image: 'appStore'
                },
              { 
                _id: '5dc59278808a68c722760982',
                name: 'Phone',
                image: 'phone',
                removed: true
                },
              { 
                _id: '5df2dc5b1fffc3daf789719a',
                name: 'Document',
                image: 'documents2',
                removed: true
                },
              { 
                _id: '5fe1dde5ac16dacfd76becad',
                name: 'Live Chat',
                image: 'chat',
                removed: true
                }
            ]
            
            let localNetworks = _.cloneDeep(this.networks);

            localNetworks = _(localNetworks).filter( platform => {
              if(_.find(menu, { _id : platform._id } )){
                let customPlatform = _.find(menu, {_id : platform._id } );
                console.log(customPlatform)
                platform.index = _.findIndex(menu, { _id: platform._id })
                platform.customName = (customPlatform.sub) ? customPlatform.sub : customPlatform.name

                if(customPlatform.imageType) {
                  platform.image = '/img/socialSvg/' + ((customPlatform.image) ? customPlatform.image : platform.name.toLowerCase().replace(/\s/g,'')) + customPlatform.imageType
                }else{
                  platform.image = '/img/socialSvg/' + ((customPlatform.image) ? customPlatform.image : platform.name.toLowerCase().replace(/\s/g,'')) + '.svg'
                }

                if(customPlatform.url){
                  platform.to = '/accounts/' + customPlatform.url
                  console.log('custom', customPlatform.url)
                }else{
                  platform.to = '/accounts/' + platform.name.toLowerCase().replace(/\s/g,'')
                  console.log('none', platform.name)
                }
                platform.removed = (customPlatform.removed) ? true : false
                platform.count = _.filter(this.accounts, { platform: platform._id}).length
                platform.isHidden = (_id) => {
                  return (this.currentWorkspaceSettings.hiddenPlatforms.includes(_id)) ? true : false
                }
                return true
              }
            }).orderBy('index').value();

            console.log('lcl, ', localNetworks)
            console.log('Vuex, ',  this.networks)

            this.setNetworks(localNetworks)

          }
        //} 
	}
</script>

<template>
	<div style="height: 100%;" class="ui grid stackable">
        <OnboardingPages v-if="modals.onboardingPages" ></OnboardingPages>
                <div style=" background: #f3f3f3; box-shadow: -4px 0px 6px rgba(0,0,0,0.03) inset;" v-bind:style="{ padding: (rightMobileMenu) ? '0px' : '15px 10px' }" v-bind:class="(rightMobileMenu) ? 'ui sidebar right visible' : 'four wide computer tablet only column' ">

                    <div v-if="rightMobileMenu" style="background:#305586; padding: 0;" class="ui basic segment">
                    <div  class="ui huge icon inverted menu">
                    <a @click="toggleRightMenu(false)" class="item">
                        <i class="right arrow icon"></i>
                    </a>
                    </div>
                    </div>

                <div style="background: transparent; padding-top:0; min-height:500px;" :class="(!currentWorkspaceSettings.loaded) ? 'loading': ''" class="ui basic segment">
                    <h5>Platforms</h5>
                    <div style="margin: 0rem -2rem 0rem -2rem;" class="ui selection list accounts">
                      <router-link v-show="(currentWorkspaceSettings.loaded && !platform.isHidden(platform._id)) && !platform.removed" v-for="platform in networks" :key="platform._id"  class="item" v-bind:class="{ active: ($router.history.current.path == platform.to) }" :to="platform.to">
                        <img class="ui avatar image" :src="platform.image">
                        <div class="content">
                          <span class="header">{{platform.customName}}</span>
                          <div style="font-size: 12px; font-style: italic;" class="description">{{platform.count}} Accounts</div>
                        </div>
                      </router-link>
                    </div>

                      <div class="ui divider"></div>
                    <div v-show="!getWhiteLabel" class="ui vertical fluid menu'">
                        <router-link class="item"  to="/community/feature-requests">
                        <span data-aos="fade"> Need a different platform ?</span>
                        <p style="font-size:11px; margin-top:5px;">Check the feature requests</p>
                                               
                        </router-link>
                    </div>
                  </div>

      </div>
        <div id="update_status" style="background: #f9f9f9;" class="twelve wide computer sixteen wide mobile column">

                        <router-view></router-view>

      </div>
	  </div>
</template>


<style scoped>

.ui.avatar.image, .ui.avatar.image img, .ui.avatar.image svg, .ui.avatar.images .image, .ui.avatar.images img, .ui.avatar.images svg {
    margin-right: .25em;
    display: inline-block;
    width: 2.2em;
    height: 2.2em;
    border-radius: 500rem;
}

.ui.selection.list.accounts a.item {
    padding: 1rem 1.5rem;
}

</style>




// WEBPACK FOOTER //
// src/components/dashboard/Accounts.vue